/**
 * KNOWN_ROUTES — allowlist of every valid pathname registered in App.js.
 * Used by RouteSEO to skip emitting default SEO for unmatched routes so
 * the NotFound page's Helmet is the ONLY <title>/canonical/robots on 404s.
 *
 * Must be kept in sync with the <Route path="..."> entries in App.js.
 * If you add or remove a route in App.js, update this list — the Semrush
 * duplicate-meta audit depends on it (step 1.2 + 1.3).
 */
const KNOWN_ROUTES = new Set([
  '/',
  '/about-us',
  '/about-ceramic-coating',
  '/admin/chats',
  '/admin6767',
  '/bio',
  '/blog/car-detailing-boca-raton',
  '/blog/ceramic-coating-boca-raton',
  '/blog/ceramic-coating-cost',
  '/blog/ceramic-coating-team',
  '/blog/ceramic-coating-why',
  '/blog/ceramic-vs-wax',
  '/blog/detailing-cost-florida',
  '/blog/faqs',
  '/blog/kovalent-ceramic-coating-complete-guide',
  '/blog/mobile-detailing-membership-packages',
  '/blog/paint-protection-film-complete-guide',
  '/blog/ppf-boca-raton',
  '/blog/ppf-cost-boca-raton',
  '/blog/ppf-vs-ceramic',
  '/blog/protect-car-florida',
  '/blog/services-boca-raton',
  '/blog/tesla-ev-ceramic-coating',
  '/blog/top-5-reasons',
  '/blog/window-tint-brands',
  '/blog/window-tinting',
  '/blogs',
  '/car-detailing',
  '/car-detailing/how-much-does-car-detailing-cost-in-florida',
  '/car-wrapping',
  '/ceramic-coating',
  '/contact',
  '/contact-us',
  '/corporate-fleet',
  '/customerinquirylist1092837465',
  '/executive',
  '/instagram',
  '/link',
  '/lp/ceramic-coating',
  '/lp/paint-protection-film',
  '/lp/ppf',
  '/marine-detailing',
  '/paint-protection-film',
  '/plane-detailing',
  '/postcard',
  '/postcard-terms',
  '/ppf',
  '/privacy-policy',
  '/reviews',
  '/shop',
  '/terms-and-conditions',
  '/thank-you',
  '/window-tint',
  // Legacy /auto-detailing city pages
  '/auto-detailing-boca-point-fl',
  '/auto-detailing-boca-raton-fl',
  '/auto-detailing-boynton-beach-fl',
  '/auto-detailing-coconut-creek-fl',
  '/auto-detailing-coral-springs-fl',
  '/auto-detailing-deerfield-beach-fl',
  '/auto-detailing-lighthouse-point-fl',
  '/auto-detailing-mission-bay-fl',
  '/auto-detailing-pompano-beach-fl',
  '/auto-detailing-west-boca-fl',
]);

export default KNOWN_ROUTES;
